
import React from "react";
import { Button } from "@/components/ui/button";
import { Save } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface SavePreferencesButtonProps {
  onClick: () => void;
  saving: boolean;
}

const SavePreferencesButton = ({ onClick, saving }: SavePreferencesButtonProps) => {
  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button 
            variant="ghost" 
            size="icon"
            className="h-7 w-7 p-0 hover:bg-muted/20 rounded-md"
            onClick={onClick}
            disabled={saving}
          >
            <Save size={16} className={`text-muted-foreground ${saving ? "animate-pulse" : ""}`} />
            <span className="sr-only">Save requirements preferences</span>
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Save requirements preferences</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default SavePreferencesButton;
